module.exports = __webpack_public_path__ + "img/bot.8603b047.svg";